import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export default function loginRedirect ({ to, from, store }) {
  if (store.state.authToken) {
    return { ...GlobalPrototypes.defaultRoute(), replace: true }
  }

  if (to.query?.redirect) return

  // For native App changing
  if (from.name === to.name) return

  if (from.name) return {name: to.name, query: {...to.params, redirect: true}, replace: true}

  const slink = store.state.slink || to.params.slink || localStorage?.getItem('slink')
  if (!slink || slink === 'undefined' || to.name === 'login-sign-in') return
  return { name: 'login-sign-in', params: { slink: slink } }
}
